// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"e88c1261","179":"23d2afaf","213":"d43b3c73","219":"0cc96293","367":"47354dbb","445":"0d09f3dd","453":"fde5c566","547":"05650164","564":"2e2c5ab8","624":"d281f6d0","732":"8cdadad6","824":"5ba95e6a","955":"b661ed67"}[chunkId] + ".chunk.js";
};